import { useState, useEffect } from 'react'
import { getSettingCertificateLevelAPI } from '../services/setting/certificate'

function UseCertificateLevel(id) {
  const [data, setData] = useState([])
  useEffect(() => {
    const getData = async () => {
      const resp = await getSettingCertificateLevelAPI({
        paymentCerBrandId: id
      })
      if (!resp) return
      if (resp.status) {
        const newData = resp.result.map((d) => {
          return { value: d.paymentCerLevelId, label: d.paymentCerLevel }
        })
        setData(newData)
      } else {
        setData([])
      }
    }
    if (id) getData()
  }, [id])

  return data
}

export default UseCertificateLevel
